import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './FAQSectionItem.css';

export const FAQSectionItem = ({
  children,
  title,
  titleElement: TitleElement = 'h3',
  description,
  ...props
}) => {
  const classes = cx('faq-section-item__title', `zui__${TitleElement}`);
  return (
    <div className="faq-section-item" {...props}>
      <TitleElement className={classes}>{title}</TitleElement>
      {description && <div className="faq-section-item__description">{description}</div>}
    </div>
  );
};

FAQSectionItem.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.node,
  titleElement: PropTypes.oneOf(['h1,', 'h2', 'h3', 'h4', 'h5', 'h6', 'span']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default FAQSectionItem;
